/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AppMarkdown.vue?vue&type=template&id=656e8149&scoped=true"
import script from "./AppMarkdown.ts?vue&type=script&lang=ts&external"
export * from "./AppMarkdown.ts?vue&type=script&lang=ts&external"
import style0 from "./AppMarkdown.vue?vue&type=style&index=0&id=656e8149&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656e8149",
  null
  
)

export default component.exports